import React from 'react';
import './App.css';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import About from './Components/About/About';
import Experience from './Components/Experience/Experience';
import Education from './Components/Education/Education';
import Project from './Components/Projects/Project';
import Contact from './Components/Contact/Contact';
import Skills from './Components/Skills/Skills';
import ScrollProgress from './Components/ScrollProgress/ScrollProgress';
import BackToTop from './Components/BackToTop/BackToTop';

function App() {
  return (
    <div className="app">
      <ScrollProgress />
      <Header />
      <Home />
      <About />
      <Experience />
      <Project />
      <Skills />
      <Education />
      <Contact />
      <BackToTop />
    </div>
  );
}

export default App;
